import React, { useState, useRef, useEffect } from 'react';
import './index.scss';
import FriendsList from './friendsList';
import { connect } from 'react-redux';
import AssignSuccessScreen from './AssignSuccessScreen';
import users from '../../../../../lib/api/users';
import Loader from '../../../../recreationAccess/reusableComponents/loader/Loader';
import SendInvite from '../send-invite';

let debouncedFind = null;

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const SearchAssigne = (props) => {
  const [searchString, setSearchString] = useState('');
  const [openFriendList, setOpenFriendList] = useState(false);
  const [assignSuccess, setAssignSuccess] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [assignedUser, setassignedUser] = useState(null)
  const [assignSpinner, setAssignSpinner] = useState(false);
  const [sendInvite, setSendInvite] = useState(false);
  const [pageNumber, setpageNumber] = useState(0)

  // const handleFind = (noStateChange) => {
  //   const { token } = props.auth;
  //   setSpinner(true);

  //   if (!noStateChange) {
  //     setOpenFriendList(true);
  //   }

  //   console.log(pageNumber, '=============>pageNumber')

  //   users
  //     .search({ searchStr: searchString, token, pageNumber, pageSize: 20 })
  //     .then((res) => {
  //       setSearchResults(res);
  //       setSpinner(false);
  //     })
  //     .catch((err) => {
  //       console.error('findFriends search error', err);
  //       setSpinner(false);
  //     });
  // };

  const handleFind = (noStateChange, overridePage) => {
    const { token } = props.auth;
    setSpinner(true);

    if (!noStateChange) {
      setOpenFriendList(true);
    }

    const page = overridePage ?? pageNumber; // use override if provided

    users
      .search({ searchStr: searchString, token, pageNumber: page, pageSize: 20 })
      .then((res) => {
        setSearchResults(res);
        setSpinner(false);
      })
      .catch((err) => {
        console.error('findFriends search error', err);
        setSpinner(false);
      });
  };

  const onChange = (e) => {
    const value = e.target.value;
    setSearchString(value);
  };

  const assignedUserConfirm = (data) => {
    setassignedUser(data)
  }
  let handlesendInvite = () => {
    setSendInvite(true)
  }


  let handleBack = () => {
    setpageNumber((prev) => {
      if (prev > 0) {
        handleFind(false, prev - 1);
        return prev - 1;
      }
      return prev; // no change if already at 0
    });

  };

  let handleNext = () => {
    setpageNumber((prev) => {
      if (searchResults.length % 20 === 0) {
        handleFind(false, prev + 1);
        return prev + 1;
      }
      return prev; // no change otherwise
    });

  };

  return (
    <div className="assign-seat-container">
      <h2 className="seat-title">Seat 2</h2>
      <p className="assign-label">
        {!assignSuccess ? 'Assign to BaseMap User:' : 'Has been assigned to:'}
      </p>

      {!assignSuccess && (
        <>
          <div style={{ width: '100%', display: 'flex' }}>
            <div className='search-filter-container' style={{ width: '100%' }}>
              <div className='search-input-container'>
                <input
                  className="user-input"
                  placeholder="Search BaseMap users by name or email"
                  id="ownerName"
                  type="text"
                  value={searchString}
                  onChange={onChange}
                  style={{ width: '98%', height: 42, outline: 'none' /* Remove default outline */ }}
                />
                <img
                  className='search-icon'
                  src='../../../asset/Search_Solid_4F4F4F_ldpi.png'
                  alt='search'
                  style={{ right: 10 }}
                  onClick={() => handleFind(false)}
                />

              </div>
            </div>

          </div>
          <p className="helper-text">
            Search BaseMap users by name or email
          </p>
        </>
      )}

      {!openFriendList && !assignSuccess && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button
            className="find-button"
            onClick={() => handleFind(false)}
          >
            FIND
          </button>
        </div>
      )}

      {openFriendList && !assignSuccess && (
        <FriendsList
          assignSuccess={() => setAssignSuccess(true)}
          friendsList={searchResults}
          spinner={spinner}
          subscriptionId={props.subscriptionId}
          assignedUserConfirm={assignedUserConfirm}
          LoadAssignSpinner={() => { setAssignSpinner(true) }}
          StopAssignSpinner={() => { setAssignSpinner(false) }}
          handlesendInvite={() => { handlesendInvite() }}
          goBack={() => { handleBack() }}
          goNext={() => { handleNext() }}
          pageNumber={pageNumber}
        />
      )}

      {assignSuccess && <AssignSuccessScreen assignedUser={assignedUser} />}

      {assignSpinner && <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>}
      {sendInvite && <SendInvite closeSendInvite={() => { setSendInvite(false) }}></SendInvite>}

    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  manageSubscription: state.manageSubscription,
  assignSubscriptionTab: state.assignSubscriptionTab,
});

export default connect(mapStateToProps)(SearchAssigne);
